export default __webpack_public_path__ + "static/media/pt_steel.bf161d2c.svg";